import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { Localize } from "@/plugins/localization";
import {
  baseGuard,
  registerGuard,
  localizationGuard,
  resetPasswordGuard
} from "./guards";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/:locale",
    component: {
      name: "RouterRoot",
      render: h => h("router-view")
    },
    redirect: {
      name: "Login"
    },
    beforeEnter: Localize.routeMiddleware,
    children: [
      {
        path: "login",
        alias: Localize.getRouteAliases("login"),
        name: "Login",
        component: () => import("@/views/Login.vue"),
        beforeEnter: baseGuard,
        meta: {
          requiresTranslation: true
        }
      },
      {
        path: "logout",
        alias: Localize.getRouteAliases("logout"),
        name: "Logout",
        component: () => import("@/views/Logout.vue"),
        beforeEnter: baseGuard,
        meta: {
          requiresTranslation: true
        }
      },
      {
        path: "register",
        alias: Localize.getRouteAliases("register"),
        name: "Register",
        component: () => import("@/views/Register.vue"),
        beforeEnter: registerGuard,
        meta: {
          requiresTranslation: true
        }
      },
      {
        path: "reset-password",
        alias: Localize.getRouteAliases("resetpassword"),
        name: "ResetPassword",
        component: () => import("@/views/ResetPassword.vue"),
        beforeEnter: resetPasswordGuard,
        props: route => ({
          uid: route.query.uid,
          expire: route.query.expire,
          hash: route.query.hash,
          token: route.query.token
        }),
        meta: {
          requiresTranslation: true
        }
      },
      {
        path: "unsubscribe",
        alias: Localize.getRouteAliases("unsubscribe"),
        name: "Unsubscribe",
        component: () => import("@/views/Unsubscribe.vue"),
        beforeEnter: baseGuard,
        meta: {
          requiresTranslation: true
        }
      },
      {
        path: "customer-dashboard",
        name: "CustomerDashboard",
        component: () =>
          import("@/views/customer-dashboard/CustomerDashboard.vue"),
        beforeEnter: baseGuard,
        props: route => ({
          email: route.query.email,
          expire: route.query.expire,
          hash: route.query.hash,
          token: route.query.token
        })
      },
      {
        path: "customer-dashboard/giftcards",
        name: "GiftcardsDashboard",
        component: () =>
          import("@/views/customer-dashboard/CustomerDashboard.vue"),
        beforeEnter: baseGuard,
        props: route => ({
          email: route.query.email,
          expire: route.query.expire,
          hash: route.query.hash,
          token: route.query.token
        })
      },
      {
        path: "customer-dashboard/review",
        name: "ReviewEntry",
        component: () => import("@/views/customer-dashboard/ReviewEntry.vue"),
        beforeEnter: baseGuard,
        props: route => ({
          email: route.query.email,
          expire: route.query.expire,
          hash: route.query.hash,
          token: route.query.token,
          review_token: route.query.review_token
        })
      },
      {
        path: "payment-method-redirect",
        alias: Localize.getRouteAliases("paymentmethodredirect"),
        name: "PaymentMethodRedirect",
        component: () => import("@/views/PaymentMethodRedirect.vue"),
        meta: {
          requiresTranslation: true
        }
        /* children: [
          {
            path: "giftcards",
            name: "GiftcardsDashboard",
            props: true
          }
        ] */
      }
    ]
  },
  {
    path: "*",
    redirect: `${Localize.defaultLocale}/login`
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(to => {
  localizationGuard(to);
});

export default router;
